import Toggle from "@dtci/spellbook/Toggle";

export const DismissButton = (props) => {
  const { data, dismissExceptionHandler } = props;
  const isResolved = data?.exceptionStatus?.toUpperCase() === "RESOLVED";
  const handleChange = () => {
    if (isResolved) return;
    if (dismissExceptionHandler) {
      dismissExceptionHandler(data);
    }
  };
  return (
    <Toggle
      labelStyle="checkNo"
      onChange={handleChange}
      checked={!!data.dismissed}
      disabled={isResolved}
    />
  );
};
